import Modal from "../../../common/ui/modal";
import {useEffect, useState} from "react";
import _ from "lodash";
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";


const DeleteDesign = ({design, removeDesign}) => {
    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Design Variant"
                content={[{
                    text: `Are you sure you wish to delete the below design?`,
                    classes: ""
                }, {
                    text: `${design?.name}`,
                    classes: "text-blue font-bold"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={true}
                handleConfirm={() => {
                    removeDesign(design)
                }}
            />
        </>
    )
}

export default DeleteDesign
